import { combineReducers } from '@reduxjs/toolkit'
import charitiesReducer from './charitiesSlice'
import investmentsReducer from './investmentsSlice'
import snp500Reducer from './snp500Slice'
import sreReducer from './sreSlice'
import stockReducer from './stockSlice'

const rootReducer = combineReducers({
  charities: charitiesReducer,
  investments: investmentsReducer,
  snp500: snp500Reducer,
  sre: sreReducer,
  stock: stockReducer,
})

export default rootReducer
